<template>
  <div class="from">
    <Button class="iviewButton" @click="back()">返回</Button>
    <div class="title">认证成为服务商</div>
    <Form ref="authenticationForm" :label-width="180" :model="formCustom">
      <Form-item label="企业名称：">
        <Input v-model="formCustom.companyName" :maxlength="50"
               clearable placeholder="请输入" style="width: 350px"></Input>
      </Form-item>
      <Form-item label="认证人姓名">
        <Input v-model="formCustom.companyName" :maxlength="50"
               clearable placeholder="请输入" style="width: 350px"></Input>
      </Form-item>
      <Form-item label="手机号">
        <Input v-model="formCustom.companyName" :maxlength="50"
               clearable placeholder="请输入" style="width: 350px"></Input>
      </Form-item>
      <Form-item label="营业执照">
        <div class="img">
          <img alt="" class="img" src="">
        </div>
      </Form-item>
      <Form-item label="承诺函">
        <el-upload
          action="https://jsonplaceholder.typicode.com/posts/"
          class="upload-demo"
          drag
          multiple>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div slot="tip" class="el-upload__tip">只能上传pdf/jpg/png格式</div>
        </el-upload>
      </Form-item>
      <Form-item label="其他资质证明">
        <el-upload
          action="https://jsonplaceholder.typicode.com/posts/"
          class="upload-demo"
          drag
          multiple>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div slot="tip" class="el-upload__tip">只能上传pdf/jpg/png格式</div>
        </el-upload>
      </Form-item>
      <Form-item>
        <Button class="next" type="primary" @click="handleSearch">确认</Button>
      </Form-item>
    </Form>
  </div>
</template>
<script>
export default ({
  name: 'authentication',
  data() {
    return {
      formCustom: {
        companyName: ''
      }
    }
  },
  mounted() {

  },
  methods: {
    back() {
      this.$router.back()
    }
  }
})
</script>

<style lang="less" scoped>
.from {
  .title {
    color: rgba(16, 16, 16, 1);
    font-size: 28px;
    margin-left: 250px;
    margin-bottom: 20px;
  }
}

.img {
  width: 360px;
  height: 180px;
}

.iviewButton {
  margin-right: 80px;
}

.next {
  border-radius: 4px;
  background-color: rgba(0, 123, 211, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  height: 50px;
  border-color: #3A62D7;
  width: 360px
}
</style>
